var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityMobileNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40267 8.66667C8.7959 8.66667 10.736 6.72657 10.736 4.33333C10.736 1.9401 8.7959 0 6.40267 0C4.00944 0 2.06934 1.9401 2.06934 4.33333C2.06934 6.72657 4.00944 8.66667 6.40267 8.66667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.155 11.6564C9.70116 12.5636 8.50212 13.8259 7.67074 15.3244C6.83937 16.8229 6.40302 18.5083 6.40278 20.222H3.51389C2.74841 20.2197 2.01494 19.9146 1.47366 19.3733C0.932385 18.832 0.627286 18.0985 0.625 17.3331L0.625 14.4442C0.628429 13.296 1.08608 12.1957 1.89799 11.3838C2.70991 10.5719 3.81012 10.1143 4.95833 10.1108H7.84722C8.47782 10.1123 9.10052 10.2513 9.67183 10.5182C10.2431 10.7852 10.7493 11.1736 11.155 11.6564Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.514 8.66667C31.9072 8.66667 33.8473 6.72657 33.8473 4.33333C33.8473 1.9401 31.9072 0 29.514 0C27.1208 0 25.1807 1.9401 25.1807 4.33333C25.1807 6.72657 27.1208 8.66667 29.514 8.66667Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2917 14.4442V17.3331C35.2894 18.0985 34.9843 18.832 34.4431 19.3733C33.9018 19.9146 33.1683 20.2197 32.4028 20.222H29.5139C29.5137 18.5083 29.0773 16.8229 28.246 15.3244C27.4146 13.8259 26.2156 12.5636 24.7617 11.6564C25.1674 11.1736 25.6736 10.7852 26.2449 10.5182C26.8162 10.2513 27.4389 10.1123 28.0695 10.1108H30.9584C32.1066 10.1143 33.2068 10.5719 34.0187 11.3838C34.8306 12.1957 35.2883 13.296 35.2917 14.4442Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9584 11.5556C21.1494 11.5556 23.7362 8.96876 23.7362 5.77778C23.7362 2.5868 21.1494 0 17.9584 0C14.7675 0 12.1807 2.5868 12.1807 5.77778C12.1807 8.96876 14.7675 11.5556 17.9584 11.5556Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6248 20.2222V21.6667C26.6214 22.8149 26.1638 23.9151 25.3518 24.727C24.5399 25.5389 23.4397 25.9966 22.2915 26H13.6248C12.4766 25.9966 11.3764 25.5389 10.5645 24.727C9.75258 23.9151 9.29493 22.8149 9.2915 21.6667V20.2222C9.2915 18.3068 10.0524 16.4698 11.4068 15.1153C12.7613 13.7609 14.5983 13 16.5137 13H19.4026C21.3181 13 23.1551 13.7609 24.5095 15.1153C25.8639 16.4698 26.6248 18.3068 26.6248 20.2222Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityMobileNav);
export default __webpack_public_path__ + "static/media/community-mobile-nav.1b3565b15b4e27b8d40eb027645d09ff.svg";
export { ForwardRef as ReactComponent };